import { PayPeriodViewModel } from "interfaces/Mueller.Business.Models";
import React, { useState } from "react";
import { MenuButton } from "react-md";

interface PayPeriodDropDownProps {
  payPeriods: PayPeriodViewModel[],
  selectedIndex?: number,
  payPeriodChangeCallback: (newIndex: number) => void,
}

const PayPeriodDropdown = (props: PayPeriodDropDownProps) => {

  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const getDropdownItems = () => {
    if (!props.payPeriods) return [];

    return (
      props.payPeriods.map(payPeriod => {
        return (
          {
            onClick: (e) => {
              let index = props.payPeriods.findIndex(p => p.fromToDisplay === e.target.innerText.trim());
              props.payPeriodChangeCallback(index);
              setSelectedIndex(index);
            },
            primaryText: payPeriod.fromToDisplay,
            key: `pay-period-id-${payPeriod.id}`,
          }
        );
      })
    );
  };



  return (
    <div className="my-time-log-filter">
      <MenuButton
        id="menu-button-3-toggle"
        position={MenuButton.Positions.BELOW}
        primary
        raised
        menuItems={getDropdownItems()}
        iconChildren="arrow_drop_down"
      >
        {props.payPeriods?.[props.selectedIndex ?? selectedIndex]?.fromToDisplay ?? ""}
      </MenuButton>
    </div>
  );
};

export default PayPeriodDropdown;
